<template>
    <div :class="showNativeShare ? 'w-100' : ''">
        <client-only>
            <!-- only on https -->
            <div v-if="showNativeShare" class="social-share share-button-wrapper">
                <UIButton variant="default" class="w-100" @click.native="nativeShare">
                    <UIIcon class="icon-share" :name="['fas', 'share-alt']" />
                    {{ label }}
                </UIButton>
            </div>
            <div v-if="!showNativeShare" class="social-share">
                <div class="label">{{ label }}</div>
                <div class="networks">
                    <ShareNetwork
                        v-for="(network, index) in networks"
                        :key="index"
                        class="share-network"
                        :network="network.network"
                        :url="shareUrl"
                        :title="item.title"
                        :description="item.description"
                        twitter-user="Dundle_com"
                    >
                        <UIButton :variant="network.button" class="btn">
                            <UIIcon class="icon-share" :name="['fab', network.icon]" />
                            {{ network.label }}
                        </UIButton>
                    </ShareNetwork>
                </div>
            </div>
        </client-only>
    </div>
</template>

<script>
import { UIButton, UIIcon } from '@dundle/ui/components';

export default {
    components: {
        UIButton,
        UIIcon,
    },

    props: {
        label: {
            type: String,
            required: true,
        },
        item: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            networks: [
                {
                    button: 'facebook',
                    network: 'facebook',
                    label: 'Facebook',
                    icon: 'facebook-f',
                },
                {
                    button: 'twitter',
                    network: 'twitter',
                    label: 'Twitter',
                    icon: 'twitter',
                },
                {
                    button: 'linkedin',
                    network: 'linkedin',
                    label: 'Linkedin',
                    icon: 'linkedin-in',
                },
                {
                    button: 'whatsapp',
                    network: 'Whatsapp',
                    label: 'Whatsapp',
                    icon: 'whatsapp',
                },
            ],
        };
    },

    computed: {
        shareUrl() {
            return `${this.$locale.currentLocale.domain}${this.$route.path}`;
        },
        showNativeShare() {
            if (process.client && navigator?.canShare) {
                return true;
            }
            return false;
        },
    },

    methods: {
        nativeShare() {
            if (this.showNativeShare) {
                navigator.share({
                    title: this.item.title,
                    url: this.shareUrl,
                });
            } else {
                console.warn(
                    'You are trying to use native social, but this is not supported. Check your https settings.'
                );
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@use 'sass:math';

.label {
    color: $color-primary-dark;
    margin-right: 1rem;
    font-weight: bold;
    margin-bottom: 0.3em;
    @media screen and (min-width: 768px) {
        font-weight: normal;
    }
}
.social-share {
    height: 100%;

    &.share-button-wrapper {
        margin-bottom: 2em;
    }
    .networks {
        margin-bottom: 2em;

        @media screen and (min-width: 768px) {
            display: flex;
            align-items: center;
        }
    }

    .share-network {
        min-width: math.div(100%, 6);

        @media screen and (min-width: 768px) {
            margin-right: 1em;
        }
        .btn {
            display: flex;
            align-items: center;
            justify-content: baseline;
            width: 100%;

            margin-bottom: 0.8em;

            svg {
                margin-right: 0.35em;
                font-size: 1.25em;
                height: 1.1em;
                width: 1.1em;
            }
        }
    }
}
</style>
